import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ListaPedidoService {

  constructor(private http: HttpService) { }

  consultSalesOrder(params: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/enterprise/onlineSaleList?sort=dataCadastro%2Cdesc&empresaVendedor', params, successHandle, errorHandle);

  }

} 
